<template>
  <div>
    <div class="storeServicebox">
      <div class="storeinputbox">
        <div class="storetitle">店铺名称<span style="font-size: 14px;color: #FC0101;">*</span></div>
        <input class="storeinput" v-model="name" placeholder="请输入店铺名称" />
      </div>
      <div class="storeinputbox">
        <div class="storetitle">店铺LOGO<span style="font-size: 14px;color: #FC0101;">*</span></div>
        <div class="serviceadd-upimgbox11">
          <div v-if="showLogo" class="serviceadd-upimgbox1">
            <img class="serviceadd-upimg" src="/static/servicelogo.png" />
          </div>
          <div v-else class="serviceadd-upimgbox1">
            <img :src="logoimg" alt="" class="serviceadd-upimg1">
          </div>
          <input type="file" class="servicefileinput" accept="image/*" @change='getimgmain($event)' />
        </div>
      </div>
<!--      <div class="storeinputbox">-->
<!--        <div class="addresstitle-box">-->
<!--          <div class="servicename">店铺地址<span style="font-size: 14px;color: #FC0101;">*</span></div>-->
<!--          <div class="addresstitletip">位置有误会影响导航，请仔细确认</div>-->
<!--        </div>-->
<!--        <div class="inspection-mesginput1">-->
<!--          <div class="inspection-addressbox">-->
<!--            <img class="inspection-mesgicon" src="/static/dizhiicon.png" />-->
<!--            <input class="inspection-name" placeholder="请选择地址" v-model="address" />-->
<!--          </div>-->
<!--          <img class="inspection-checkmore" src="/static/dingwei.png" @click="toChooseLocation()" />-->
<!--        </div>-->
<!--      </div>-->
      <div class="storeinputbox">
        <div class="storetitle">所在地区<span style="font-size: 14px;color: #FC0101;">*</span></div>
        <!-- <input class="addressAdd_input" v-model="addressProvince" placeholder="省"/>
				<input class="addressAdd_input" v-model="addressCity" placeholder="市" />
				<input class="addressAdd_input" v-model="addressArea"  placeholder="区"/> -->

<!--        <div @click="toAddress" class="address">{{addressProvince}}-{{addressCity}}-{{addressArea}}</div>-->
        <div @click="toAddress" :class="city ? 'addressselect1' : 'addressselect'">{{city ? city : '请选择地址'}}</div>
        <!-- <mt-picker :slots="addressSlots" class="picker" @change="onAddressChange" :visible-item-count="5"></mt-picker>
				省市区:{{ addressProvince }} {{ addressCity }} -->
        <van-popup v-model="showaddress" round closeable position="bottom" :style="{ height: '40%' }" >
          <van-area  :area-list="areaList" @confirm="confirmaddress" @cancel="canceladdress" />
        </van-popup>
      </div>
      <div class="storeinputbox">
        <div class="storetitle">收货地址详细描述<span style="font-size: 14px;color: #FC0101;">*</span></div>
        <input class="storeinput" placeholder="请输入详细地址" v-model="desc" />
      </div>
      <div class="storeinputbox">
        <div class="storetitle">联系人<span style="font-size: 14px;color: #FC0101;">*</span></div>
        <input class="storeinput" v-model="contactName" placeholder="请输入联系人姓名" />
      </div>
      <div class="storeinputbox">
        <div class="storetitle">手机号码<span style="font-size: 14px;color: #FC0101;">*</span></div>
        <input class="storeinput" v-model="phone" placeholder="请输入手机号码" />
      </div>
      <div class="storeinputbox">
        <div class="storetitle">登录密码<span style="font-size: 14px;color: #FC0101;">*</span></div>
        <input class="storeinput" type="password" v-model="password" placeholder="请输入登录密码" />
      </div>
      <div class="storeinputbox">
        <div class="storetitle">店铺服务<span style="font-size: 14px;color: #FC0101;">*（多选）</span></div>
        <div class="serviceList">
          <div :class="item.check ? 'servicedetailbox1' : 'servicedetailbox'" @click="changeservice(item,index)" v-for="(item,index) in serviceList">{{item.name}}</div>
        </div>
      </div>
      <div class="storeinputbox" v-if="servicePricelist.length>0">
        <div class="storetitle">价格修改<span style="font-size: 14px;color: #FC0101;">*</span></div>
        <div class="servicepricebox" v-for="(item,index) in servicePricelist">
          <div class="servicename">{{item.name}}</div>
          <div class="servicepriceright">
            <div class="pricebox">
              <div class="pricetitle">售价/元</div>
              <div class="priceinputbox">
                <input class="priceinput" :value="item.price" type="number" @change="changePrice($event,item.id)"
                  placeholder="请输入价格" />
              </div>
            </div>
            <div class="pricebox">
              <div class="pricetitle1">结算价/元</div>
              <div class="priceinputbox">
                <input class="priceinput" type="number" placeholder="请输入价格" :value="item.business_price" @change="changeSettlementPrice($event, item.id)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="serviceConfirm" @click="confirm">确认提交</div>
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  import { areaList } from '@vant/area-data';
  export default {
    data() {
      return {
        name: "",//店铺名
        contactName:"",//联系人
        phone: "",//电话
        password: "",//密码
        address1: "",//省市经纬度等
        address: "",//详细地址
        desc: "",
        areaList,
        addressProvince: '省',
        addressCity: '市',
        addressArea: '区',
        addressStreet: '街道',
        city:'',
        addInp: false,
        mask: false,
        showaddress:false,
        serviceList: [{
          id: 1,
          name: "安全检测",
          check: false
        }, {
          id: 2,
          name: "洗车",
          check: false
        }, {
          id: 3,
          name: "车内消毒",
          check: false
        }, {
          id: 4,
          name: "机油保养",
          check: false
        }, {
          id: 5,
          name: "标准打蜡",
          check: false
        }, {
          id: 6,
          name: "划痕补漆",
          check: false
        }, {
          id: 7,
          name: "空调清洗",
          check: false
        }, {
          id: 8,
          name: "补胎",
          check: false
        }, {
          id: 9,
          name: "车辆年检",
          check: false
        }],
        servicePricelist: [],
        showLogo:true,//是否展示logo
        logoimg:"",//logo图片
        // {
        //   id: 1,
        //   name: "安全检测",
        //   price: 0,
        //   business_price: 0
        // }
      }
    },
    created() {
      // this.getwechat({
      //   url: location.href.split('#')[0]
      // })
      if (this.$route.query.phone) {
        this.phone = this.$route.query.phone;
      } else {
        this.phone = ""
      }
      if (this.$route.query.contactName) {
        this.contactName = this.$route.query.contactName;
      } else {
        this.contactName = "";
      }
      if (this.$route.query.logoimg) {
        this.logoimg = this.$route.query.logoimg;
      } else {
        this.logoimg = "";
      }
      if (this.$route.query.name) {
        this.name = this.$route.query.name;
      } else {
        this.name = ""
      }
      if (this.$route.query.password) {
        this.password = this.$route.query.password;
      } else {
        this.password = ""
      }
      console.log("this.$route.query.address", this.$route.query.address)
      if (this.$route.query.address) {
        this.address1 = JSON.parse(this.$route.query.address)
        console.log("add", this.address1)
        if (this.address1.pname) {
          this.address = this.address1.pname + this.address1.cityname + this.address1.address + this.address1.name
        } else {
          this.address = this.address1.address + this.address1.name
        }
      } else {
        this.address1 = ""
        this.address = ""
      }
      if (this.$route.query.serviceList) {
        this.serviceList = JSON.parse(this.$route.query.serviceList)
      } else {
        this.request("getserviceList")
      }
      if (this.$route.query.servicePricelist) {
        this.servicePricelist = JSON.parse(this.$route.query.servicePricelist)
      } else {
        this.servicePricelist = []
      }

    },
    mounted() {

    },
    methods: {
      toAddress() {
        this.mask = true;
        this.addInp = true;
        this.showaddress= true
      },
      confirmaddress(e){
        console.log("地址", e)
        this.showaddress= false
        this.addressProvince = e[0].name
        this.addressCity = e[1].name
        this.addressArea = e[2].name
        this.city = `${this.addressProvince}-${this.addressCity}-${this.addressArea}`
      },
      canceladdress(){
        this.showaddress= false
      },
      // 省市区三级联动
      selected(data) {
        this.mask = false;
        this.addInp = false;
        console.log("地址", data)
        this.addressProvince = data.province.value
        this.addressCity = data.city.value
        this.addressArea = data.area.value
        //this.city = `${this.addressProvince}-${this.addressCity}-${this.addressArea}`
      },
      //商铺logo
      getimgmain(e) {
        let that = this;
        let requestData = {}
        var files = e.target.files[0];
        if (!files) return
        let reader = new FileReader();
        reader.readAsDataURL(files); // 读取文件
        reader.onloadend = function(res) {
          that.showLogo = false;
          requestData.base64_file = res.currentTarget.result;
          that.request("upimg", requestData)
        }
      },
      //改变服务
      changeservice(itemstr, indexstr) {
        // let that = this
        // let servicelist = that.serviceList
        // servicelist.map((item,index)=>item.check=index==indexstr)
        // that.serviceList = servicelist
        // that.serviceId = servicelist[indexstr].id
        if (!this.serviceList[indexstr].check) {
          this.serviceList[indexstr].check = true
          this.servicePricelist.push({
            id: itemstr.id,
            name: itemstr.name,
            price: itemstr.price,
            business_price: itemstr.business_price
          })
          console.log("this.serviceList", this.serviceList)
          console.log("this.servicePricelist", this.servicePricelist)
        } else {
          this.serviceList[indexstr].check = false
          this.servicePricelist.map((item, index) => {
            if (item.id == itemstr.id) {
              this.servicePricelist.splice(index, 1)
            }
          })
          console.log("this.serviceList1", this.serviceList)
          console.log("this.servicePricelist1", this.servicePricelist)
        }
      },
      //改变售价
      changePrice(event, id) {
        this.servicePricelist.map((item, index) => {
          if (item.id == id) {
            item.price = Number(event.target.value)
          }
        })
        console.log("this.servicePricelist5", this.servicePricelist)
      },
      //改变结算价
      changeSettlementPrice(event, id) {
        this.servicePricelist.map((item, index) => {
          if (item.id == id) {
            item.business_price = Number(event.target.value)
          }
        })
        console.log("this.servicePricelist6", this.servicePricelist)
      },
//确认
      confirm() {
        let that = this
        let requestData = {}
        this.address = `${this.addressProvince}${this.addressCity}${this.addressArea}${this.desc}`
        console.log("地址：",this.address)
        if (!this.name) {
          this.$toast({
            message: '请输入店铺名称',
          })
          return
        } else {
          requestData.name = this.name
        }
        if (!this.logoimg) {
          this.$toast({
            message: '请上传店铺logo',
          })
          return
        } else {
          requestData.thumb_url = this.logoimg
        }
        if (!this.address) {
          this.$toast({
            message: '请选择地址',
          })
          return
        } else {
          requestData.address = this.address
          // requestData.lat = this.address1.location.lat
          // requestData.lng = this.address1.location.lng
          // requestData.city = this.address1.cityname
          // requestData.province = this.address1.pname
          requestData.lat = 1
          requestData.lng = 1
          requestData.city = this.addressCity
          requestData.province = this.addressProvince
        }
        if (!this.contactName) {
          this.$toast({
            message: '请输入联系人姓名',
          })
          return
        } else {
          requestData.store_manager = this.contactName
        }
        if (!this.phone) {
          this.$toast({
            message: '请输入手机号码',
          })
          return
        } else {
          requestData.mobile = this.phone
        }
        if (!this.password) {
          this.$toast({
            message: '请输入密码',
          })
          return
        } else {
          requestData.password = this.password
        }
        // let servicelist = this.servicePricelist
        // servicelist.map((item, index) => {
        //   delete item.name
        // })
        // console.log("servicelist",servicelist)
        requestData.services = this.servicePricelist
         console.log("requestData", requestData)
        this.request("storein", requestData)
      },
      //获取微信配置信息接口
      // getwechat(requestData = {}) {
      //   httper.get("wechat/wechat/sign-package", requestData, res => {
      //     console.log(res);
      //     wx.config({
      //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      //       appId: res.appId, // 必填，公众号的唯一标识
      //       timestamp: res.timestamp, // 必填，生成签名的时间戳
      //       nonceStr: res.nonceStr, // 必填，生成签名的随机串
      //       signature: res.signature, // 必填，签名
      //       jsApiList: ["getLocation", "openLocation"] // 必填，需要使用的JS接口列表
      //     });
      //   });
      // },
      // //获取定位
      // getMyLocation() {
      //   let that = this
      //   wx.getLocation({
      //     type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      //     success: function(res) {
      //       that.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
      //       that.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
      //       // var speed = res.speed; // 速度，以米/每秒计
      //       // var accuracy = res.accuracy; // 位置精度
      //     }
      //   });
      //   if (this.storeDesc && this.latitude) {
      //     console.log("纬度", Number(this.latitude)) //接口获取店铺信息获得经纬度
      //     console.log("经度", Number(this.longitude))
      //     // wx.ready(() => {
      //     // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      //     wx.openLocation({
      //       latitude: Number(this.latitude), // 纬度，浮点数，范围为90 ~ -90
      //       longitude: Number(this.longitude), // 经度，浮点数，范围为180 ~ -180。
      //       name: this.storeDesc.name,
      //       address: this.storeDesc.address,
      //       scale: 16
      //     });
      //     // });
      //   }
      // },
      //腾讯地图选择地址
      toChooseLocation() {
        this.$router.push({
          path: "/chooseLocation",
          query: {
            name: this.name, //联系人
            phone: this.phone, //联系人电话
            password: this.password,//密码
            contactName:this.contactName,//联系人
            logoimg:this.logoimg,//logo
            serviceList: JSON.stringify(this.serviceList),
            servicePricelist: JSON.stringify(this.servicePricelist),
            items: "storeService"
          }
        })
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        let data = {}
        switch (type) {
          // 获取服务列表
          case 'getserviceList':
            httper.get('store-input/service-product', requestData, res => {
              if (res.code == 0) {
                this.serviceList = res.data
                this.serviceList.map(v => {
                  this.$set(v, 'check', false)
                  return v
                })
                console.log("serviceList", this.serviceList)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, false)
            break
            //确认
          case 'storein':
            httper.post('store-input/store-in', requestData, res => {
              if (res.code == 0) {
                Dialog.alert({
                  title: '提示',
                  message: '提交成功！',
                }).then(() => {
                  window.location.reload() //页面刷新
                });
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, false)
            break
            //logo
            case 'upimg':
              httper.post('media/base64-upload', requestData, res => {
                if (res.code == 0) {
                  this.logoimg = res.data.src
                } else {
                  this.$toast({
                    message: res.message || '系统异常'
                  })
                }

              },false)
              break
        }
      }
    }
  }
</script>

<style scoped="scoped">
.van-picker__toolbar{
  height: auto;
}
  input {
    border: none;
    outline: none;
  }

  ::-webkit-input-placeholder {
    font-size: 14px;
    color: #BBBBBB;
    text-align: left;
  }

  body {
    background-color: #F2F2F2;
  }

  .storeServicebox {
    width: calc(100% - 40px);
    margin: 20px;
  }

  .storeinputbox {
    width: 100%;
    background-color: #FFFFFF;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
  }

  .storetitle {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .addresstitle-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .addresstitletip {
    color: #BBBBBB;
    font-size: 14px;
  }

  .storeinput {
    width: 100%;
    font-size: 14px;
  }

  .serviceList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .servicedetailbox {
    width: 30%;
    height: 35px;
    border: 1px solid #FD8C00;
    border-radius: 17px;
    margin: 10px 3px;
    font-size: 14px;
    color:#FD8C00;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .servicedetailbox1 {
    width: 30%;
    height: 35px;
    background-color: #FD8C00;
    border-radius: 17px;
    margin: 10px 3px;
    font-size: 14px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 定位 开始 */
  .inspection-mesginput1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: 30px;
    width: 100%;
  }

  .inspection-addressbox {
    display: flex;
    align-items: center;
    width: 88%;
  }

  .inspection-mesgicon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .inspection-checkmore {
    width: 15px;
    height: 15px;
  }

  .inspection-name {
    font-size: 16px;
    height: 30px;
    width: 280px;
  }

  /* 定位 结束 */
  .servicepricebox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 20px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #E5E5E5;
  }

  .servicename {
    font-size: 14px;
  }

  .servicepriceright {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .pricebox {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .pricetitle {
    font-size: 14px;
    color: #FD8C00;
    margin-right: 26px;
  }

  .pricetitle1 {
    font-size: 14px;
    color: #FD8C00;
    margin-right: 12px;
  }

  .priceinputbox {
    width: 115px;
    height: 35px;
    border: 1px solid #FD8C00;
    border-radius: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    padding: 5px;
    box-sizing: border-box;
  }
  .addressselect{
    font-size: 14px;
    color: #bbbbbb;
  }
.addressselect1{
  font-size: 14px;
  color: #000000;
}

  .priceinput {
    width: 100%;
    font-size: 14px;
  }

  .serviceConfirm {
    width: calc(100% - 40px);
    margin: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #FFFFFF;
    height: 48px;
    background:#FD8C00;
    border-radius: 24px;
  }
  .serviceadd-upimgbox11{
    width: 100%;
    position: relative;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .serviceadd-upimgbox1 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .servicefileinput {
    opacity: 0;
    position: absolute;
    cursor: pointer;
    width: 100%;
    height: 100%;
  }

  .serviceadd-upimg {
    width: 100%;
    height: 100%;
  }

  .serviceadd-upimg1 {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 220px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/storeService/storeService.vue